import React, { useEffect, useState } from 'react';
import { Breadcrumbs, FileUploader, Input, Multiselect } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import useEditDealContext from 'contexts/edit-deal.context';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { Editor } from 'react-draft-wysiwyg';
import './styles.scss';
import draftToHtml from 'draftjs-to-html';
import { ContentState, convertFromHTML, convertToRaw, EditorState } from 'draft-js';
import useDashboardContext from 'contexts/dashboard.context';
import _ from 'lodash';
import PageLoader from 'components/base/page-loader';

const EditDealDetails = () => {
  const [textEditorState, setTextEditorState] = useState<EditorState>();
  const {
    editDealForm,
    setEditDealForm,
    handleChange,
    setDisabled,
    initialEditData,
    dealToEdit,
    dealLoading
  } = useEditDealContext();
  const { cokitchens } = useDashboardContext();

  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;

  const breadcrumbs = [
    { name: 'Deals & Discount', path: ROUTE_KEYS.DEALS_AND_DISCOUNTS },
    { name: 'Edit Deal & Discount', path: ROUTE_KEYS.CREATE_DEAL }
  ];

  useEffect(() => {
    if (dealToEdit) {
      let body;
      try {
        body = convertFromHTML(JSON.parse(dealToEdit.body)).contentBlocks;
      } catch (error) {
        return;
      }
      setTextEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(body)));
    }
  }, [dealToEdit]);

  const handleEditorStateChange = (e: EditorState) => {
    setTextEditorState(e);
    setEditDealForm({
      ...editDealForm,
      body: JSON.stringify(draftToHtml(convertToRaw(e.getCurrentContent())))
    });
  };

  useEffect(() => {
    if (
      !editDealForm.heading ||
      !editDealForm.title ||
      !editDealForm.body ||
      !editDealForm.images.length ||
      !editDealForm.cokitchen_id
    ) {
      setDisabled(true);
    } else {
      const hasChanged = !_.isEqual(initialEditData, editDealForm);
      if (hasChanged) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [editDealForm]);

  if (dealLoading || !dealToEdit) return <PageLoader />;
  return (
    <div className='mx-10 pt-8 max-w-[700px]'>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className='mt-8'>
        <PageHeaderText
          title='Edit Deal & Discount'
          description='Edit a new deal lorem dolum ipsum'
        />
      </div>
      <Input
        type='text'
        label='Post heading'
        name='heading'
        value={editDealForm.heading}
        onChange={(e) => handleChange(e)}
        className='mb-6'
        placeholder='Post heading'
        inputClass='h-[50px]'
      />
      <Input
        type='text'
        label='Post title'
        name='title'
        value={editDealForm.title}
        onChange={(e) => handleChange(e)}
        className='mb-6'
        placeholder='Eat Good, Pay Less.'
        inputClass='h-[50px]'
      />
      <p className='text-black mb-1.5'>Post body</p>
      <Editor
        editorState={textEditorState}
        toolbarClassName='toolbarClassName'
        wrapperClassName='wrapperClassName'
        editorClassName='editorClassName'
        onEditorStateChange={handleEditorStateChange}
        placeholder="You Know how you buy a really awesome gift for someone and you're just so excited out of your shoes for the person to experience it? 🤭 Think that, think Red Pepper! 🌶️📸
with ❤️"
      />
      <p className='font-medium mt-5'>Add post image</p>
      <FileUploader
        className='p-0 border-0'
        token={token}
        setFileUrls={(urls) => {
          setEditDealForm({
            ...editDealForm,
            images: urls
          });
        }}
        fileUrls={editDealForm.images}
      />
      <div>
        <label className='font-medium'>Location</label>
        <Multiselect
          isSingle
          placeholder='Select Location'
          values={[editDealForm.cokitchen_id]}
          options={cokitchens.map((c) => ({
            text: c.name,
            value: c.id
          }))}
          onChange={(cokitchens) =>
            setEditDealForm({
              ...editDealForm,
              cokitchen_id: cokitchens?.[0]
            })
          }
        />
      </div>
    </div>
  );
};

export default EditDealDetails;
